import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DataProvider } from 'src/providers/data/data';

@Component({
  selector: 'app-point-edit-comp',
  templateUrl: './point-edit-comp.component.html',
  styleUrls: ['./point-edit-comp.component.scss'],
})
export class PointEditCompComponent implements OnInit {
  constructor(
    private router: Router,
    public data: DataProvider,
    private route: ActivatedRoute,
    public translate: TranslateService,
  ) {}

  ngOnInit() {
    this.data.menuPageTitle = 'wf-point';
    this.data.ClubCode = '';
    this.data.ContractTypeCode = '';
    this.data.memberID = '';
    this.data.memberName = '';
    this.data.Point = '';
    this.widthChanger('main-header', 360);
  }

  back() {
    this.router.navigate(['/wf-point']);
    sessionStorage.clear();
  }
  widthChanger(className, width) {
    const headers = document.getElementsByClassName(className);
        for (let i = 0; i < headers.length; i++) {
          const header = headers[i] as HTMLElement;
          
          header.style.minWidth = width.toString() + 'px';
      }
  }
}
